// Pure search helpers: matching a profile against a query, and tracing the
// intro path from a degree-2 target up to "You". Extracted from useSearch so the
// path walk — the part most likely to silently break — has a test surface.

import { matchesPublishedProfile } from "./profilePublication";

/** Does any searchable field on `profile` contain `query` (case-insensitive)? */
export function matchesQuery(profile, query) {
  return matchesPublishedProfile(profile, query);
}

/**
 * Walk `parentUid` from `startNode` up to the degree-0 "You" node.
 * @returns {{ path: string[], complete: boolean }}
 *   `complete` is true when the chain reached You on its own. When it can't,
 *   You is prepended so the UI still renders a rooted chain, and `complete`
 *   stays false so callers can tell the path had a gap.
 */
export function buildPath(nodeMap, startNode, youId) {
  const path = [];
  const seen = new Set();
  let current = startNode;
  let complete = false;

  while (current && !seen.has(current.id) && path.length < 32) {
    seen.add(current.id);
    path.unshift(current.id);
    if (current.degree === 0) {
      complete = true;
      break;
    }
    current = nodeMap.get(current.parentUid);
  }

  if (!complete && youId && path[0] !== youId) {
    path.unshift(youId);
  }
  return { path, complete };
}
